<template>
  <a-modal
    :open="visible"
    title="功能激活"
    :confirm-loading="loading"
    ok-text="激活"
    cancel-text="取消"
    @ok="handleActivate"
    @cancel="handleCancel"
  >
    <p v-if="targetLabel" class="hint">
      您正在尝试使用「{{ targetLabel }}」，请输入功能激活码解锁。
    </p>
    <p v-else class="hint">输入功能激活码，解锁对应的首页功能模块。</p>
    <a-input
      v-model:value="code"
      placeholder="请输入激活码"
      allow-clear
      @pressEnter="handleActivate"
    />
    <p v-if="error" class="error">{{ error }}</p>
  </a-modal>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue'
import { message } from 'ant-design-vue'
import { useModuleStore } from '@/store/module'

export default defineComponent({
  name: 'ModuleActivationModal',
  setup() {
    const moduleStore = useModuleStore()
    const code = ref('')
    const loading = ref(false)
    const error = ref('')

    const visible = computed({
      get: () => moduleStore.activationModalVisible,
      set: (val: boolean) => {
        if (!val) moduleStore.closeActivationModal()
      }
    })

    const targetLabel = computed(() => moduleStore.activationTarget?.title || moduleStore.activationTarget?.label || '')

    watch(visible, (open) => {
      if (open) {
        code.value = ''
        error.value = ''
      }
    })

    async function handleActivate() {
      const trimmed = code.value.trim()
      if (!trimmed) {
        error.value = '请输入激活码'
        return
      }
      loading.value = true
      error.value = ''
      try {
        const data = await moduleStore.activateCode(trimmed, moduleStore.activationTarget?.moduleCode || null)
        const targetTitle = moduleStore.activationTarget?.title
        message.success(targetTitle ? `激活成功，已解锁「${targetTitle}」` : '激活成功')
        moduleStore.closeActivationModal()
        return data
      } catch (e: unknown) {
        error.value = (e as Error)?.message || '激活失败'
      } finally {
        loading.value = false
      }
    }

    function handleCancel() {
      moduleStore.closeActivationModal()
    }

    return {
      visible,
      code,
      loading,
      error,
      targetLabel,
      handleActivate,
      handleCancel
    }
  }
})
</script>

<style scoped>
.hint {
  margin-bottom: 12px;
  color: #595959;
}

.error {
  margin-top: 8px;
  color: #cf1322;
}
</style>
